import { BusinessType } from '@prisma/client';

import { TargetAccount } from '../hooks/useTargetAccount';

export const getHeaderLinksByBusinessType = (targetAccount: TargetAccount) => {
  if (
    (targetAccount?.business_type === BusinessType.FREIGHT_FORWARDER ||
      targetAccount?.business_type === BusinessType.GSA) &&
    !targetAccount?.is_fulfillment_partner
  ) {
    return [
      {
        title: 'New Request',
        href: '/',
      },
      {
        title: 'Requests',
        href: '/requests',
      },
      /*{
        title: 'Metrics',
        href: '/metrics',
      },*/
    ];
  }

  const is_fulfillment_partner = !!targetAccount?.is_fulfillment_partner;
  if (
    (targetAccount?.business_type === BusinessType.FREIGHT_FORWARDER ||
      targetAccount?.business_type === BusinessType.GSA) &&
    is_fulfillment_partner
  ) {
    return [
      {
        title: 'New Request',
        href: '/',
      },
      {
        title: 'Requests',
        href: '/requests',
      },
      {
        title: 'Marketplace',
        href: '/marketplace',
      },
      {
        title: 'Metrics',
        href: '/metrics',
      },
    ];
  }

  if (targetAccount?.business_type === BusinessType.AIRLINE) {
    return [
      {
        title: 'Dashboard',
        href: '/metrics',
      },
    ];
  }

  return [];
};
